import React, { useRef } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import GoalsWrapper from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/goal-provider';
import Roadmap from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap';
import RoadmapExportWrapper from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/roadmap-wrapper/export';
import Header from './header';
import Legend from './legend';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { ExportViewProps } from './types';
import ViewInformation from './view-information';

export default function ExportView({ onLoadComplete, appWidth }: ExportViewProps) {
	const roadmapContainerRef = useRef<HTMLDivElement>(null);

	return (
		<GoalsWrapper>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.container} style={{ width: appWidth }}>
				<Header />
				<ViewInformation />
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
				<div className={styles.main}>
					{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
					<div className={styles.roadmap} ref={roadmapContainerRef}>
						{/* When cleaning up FF com.atlassian.rm.jpo.transposition we can just render <PlanTableAsync /> */}
						{ff('com.atlassian.rm.jpo.transposition') ? (
							<RoadmapExportWrapper
								containerRef={roadmapContainerRef}
								onLoadComplete={onLoadComplete}
								appWidth={appWidth}
							/>
						) : (
							<Roadmap
								containerRef={roadmapContainerRef}
								onLoadComplete={onLoadComplete}
								appWidth={appWidth}
							/>
						)}
					</div>
				</div>
				<Legend />
			</div>
		</GoalsWrapper>
	);
}
